import React from 'react';

import { ComponentLoadingFallback } from '@components/ui/ComponentLoadingFallback';

import { DropZoneAreaBase } from './DropZoneAreaBase';

import type { DropZoneProperties, FileObject } from './DropZone.types';
import type { FileWithPath } from 'react-dropzone';

export const DropZone: React.FC<DropZoneProperties> = ({
  dataTest = 'dropzone',
  filesCount = 0,
  accept,
  filesLimit = 1,
  icon,
  maxFileSize,
  dropzoneText,
  disableRejectionFeedback,
  getFileAddedMessage,
  getFileLimitExceedMessage,
  getDropRejectMessage,
  onDrop,
  onDropRejected,
  inputProps,
  dropzoneProps,
  disabled,
  dropZoneStyles = [],
  dropzoneParagraphStyles = [],
}) => {
  const [fileObjects, setFileObject] = React.useState<FileObject[]>([]);

  const addFiles = async (newFiles: FileWithPath[]) => {
    const newFileObjects = newFiles.map((file): FileObject => {
      return {
        name: file.name,
        type: file.type,
        size: file.size,
        path: file.path,
        lastModified: file.lastModified,
        webkitRelativePath: file.webkitRelativePath,
      };
    });
    setFileObject([...fileObjects, ...newFileObjects]);
  };

  return (
    <React.Suspense fallback={<ComponentLoadingFallback />}>
      <DropZoneAreaBase
        filesCount={filesCount}
        dataTest={dataTest}
        accept={accept}
        filesLimit={filesLimit}
        icon={icon}
        fileObjects={fileObjects}
        maxFileSize={maxFileSize}
        dropzoneText={dropzoneText}
        disableRejectionFeedback={disableRejectionFeedback}
        getFileAddedMessage={getFileAddedMessage}
        getFileLimitExceedMessage={getFileLimitExceedMessage}
        getDropRejectMessage={getDropRejectMessage}
        onAdd={addFiles}
        onDrop={onDrop}
        onDropRejected={onDropRejected}
        inputProps={inputProps}
        dropzoneProps={dropzoneProps}
        dropZoneStyles={dropZoneStyles}
        dropzoneParagraphStyles={dropzoneParagraphStyles}
        disabled={disabled}
      />
    </React.Suspense>
  );
};
